import Table from "@/components/Table/table";
import {
  MotifButton,
  MotifIcon,
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
  MotifModalHeader,
  MotifToggleSwitch,
} from "@ey-xd/motif-react";
import {
  useDeleteLimitAmountMutation,
  useGetCalculationStepLimitAmountApiDataQuery,
  useGetManualDataSourceApiDataQuery,
  useUpdateCapAndFloorLimitMutation,
} from "./calculationStepReducer";
import { useEffect, useState } from "react";
import LimitAmountForm from "./FormModal/LimitAmountForm";
import { IconoirWarningTriangle } from "@ey-xd/motif-icon";
import LimitAmountFormNew from "./FormModal/LimitAmountFormNew";
import { useTranslation } from "react-i18next";
import {
  havingAddPermission,
  havingDeletePermission,
  havingEditPermission,
} from "@/utility/common";
import {
  CANCEL_BUTTON_VARIANT,
  GetCommonDeleteImgButton,
  YES_BUTTON_VARIANT,
} from "@/components/Images/CommonImages";
import { useNavigate, useParams } from "react-router-dom";

export const CalculationStepLimitAmount = ({
  caseId,
  stepId,
  dataByStepId,
  distributionStatus,
  StepLimitAmount,
}: any) => {
  const { distributionId } = useParams<{
    distributionId: string;
  }>();
  const { t } = useTranslation();
  const [createShow, setCreateShow] = useState(false);
  const [updateShow, setUpdateShow] = useState(false);
  const [editId, setEditId] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [deleteId, setDeleteId] = useState("");
  const { data, refetch, isFetching } =
    useGetCalculationStepLimitAmountApiDataQuery(stepId);
  const { data: manualDataSource } = useGetManualDataSourceApiDataQuery(caseId);
  const disbaleFileds = havingEditPermission(StepLimitAmount) ? false : true;
  const [updateCapAndFloorLimit] = useUpdateCapAndFloorLimitMutation();
  const [isZeroLimit, setIsZeroLimit] = useState({
    limitAsCap: false,
    limitAsFloor: false,
    limitAmountOrder: 0,
  });
  const nav = useNavigate();
  useEffect(() => {
    if (dataByStepId) {
      setIsZeroLimit({
        limitAsCap: dataByStepId?.isCapZeroLimit || false,
        limitAsFloor: dataByStepId?.isFloorZeroLimit || false,
        limitAmountOrder: dataByStepId?.limitAmountOrder || 0,
      });
    }
  }, [dataByStepId]);

  const handleZeroLimitChange = (name: any, checked: any) => {
    setIsZeroLimit({ ...isZeroLimit, [name]: checked });
    const capAndFloorData = {
      calculationStepId: stepId,
      isCapZeroLimit: name === "limitAsCap" ? checked : isZeroLimit.limitAsCap,
      isFloorZeroLimit:
        name === "limitAsFloor" ? checked : isZeroLimit.limitAsFloor,
      limitAmountOrder:
        name === "limitAmountOrder"
          ? checked
            ? 1
            : 0
          : isZeroLimit.limitAmountOrder
          ? 1
          : 0,
    };
    updateCapAndFloorLimit(capAndFloorData).then((response: any) => {
      if (response.hasOwnProperty("data")) {
        refetch();
      }
    });
  };
  useEffect(() => {
    refetch();
    // eslint-disable-next-line
  }, [dataByStepId]);
  const TitleComplement = () => {
    const { t } = useTranslation();
    return (
      <div className="Limit-amount-toogles-con">
        <MotifToggleSwitch
          style={{ width: "200px"}}
          id="limitAsCap"
          onLabel={"Cap Limit to Zero"}
          offLabel={"No Limit Applied"}
          onChange={(e: any) =>
            handleZeroLimitChange("limitAsCap", e.target.checked)
          }
          checked={isZeroLimit?.limitAsCap ? true : false}
          /*@ts-ignore */
          // value={isZeroLimit?.limitAsCap}
          disabled={distributionStatus || disbaleFileds}
        />

        <MotifToggleSwitch
          style={{ width: "200px"}}
          id="limitAsFloor"
          onLabel={"Floor Limit to Zero"}
          offLabel={"No Limit Applied"}
          onChange={(e: any) =>
            handleZeroLimitChange("limitAsFloor", e.target.checked)
          }
          checked={isZeroLimit?.limitAsFloor ? true : false}
          disabled={distributionStatus || disbaleFileds}
        />
        <MotifToggleSwitch
          style={{ width: "200px"}}
          id="applyCapOrFloorFirst3"
          onLabel={t(
            "pages.distributions.distributionStepsTab.limitAmountTab.applyCapFirst"
          )}
          offLabel={t(
            "pages.distributions.distributionStepsTab.limitAmountTab.applyFloorFirst"
          )}
          onChange={(e: any) =>
            handleZeroLimitChange("limitAmountOrder", e.target.checked)
          }
          checked={isZeroLimit?.limitAmountOrder ? true : false}
          disabled={distributionStatus || disbaleFileds}
        />

        {havingAddPermission(StepLimitAmount || []) && (
          <MotifButton
            onClick={() => {
              setCreateShow(true);
              setEditId("");
            }}
            disabled={distributionStatus}
            size="small"
            type="submit"
            variant="secondary"
          >
            {t(
              "pages.distributions.distributionStepsTab.limitAmountTab.createLimitAmount"
            )}{" "}
          </MotifButton>
        )}
      </div>
    );
  };
  const columnClassFilterDefs = [
    {
      field: "limitType",
      headerName: t(
        "pages.distributions.distributionStepsTab.limitAmountTab.columnDetails.column1"
      ),
      width: "150",
      cellRenderer: function (params: any) {
        return (
          <div
            style={{
              cursor: havingEditPermission(StepLimitAmount || [])
                ? "pointer"
                : "default",
            }}
            onClick={() => {
              if (havingEditPermission(StepLimitAmount || [])) {
                setUpdateShow(true);
                setEditId(params?.data?.id);
              }
            }}
            className={
              havingEditPermission(StepLimitAmount || [])
                ? "text-bold-underline"
                : ""
            }
          >
            {params?.data.limitType === 0 ? "Floor" : "Cap"}
          </div>
        );
      },
    },
    // {
    //   field: "isZeroLimit",
    //   headerName: "Use zero limit",
    //   width: "150",
    // },
    {
      field: "dataSourceType",
      headerName: t(
        "pages.distributions.distributionStepsTab.limitAmountTab.columnDetails.column2"
      ),
      sort: "asc",
      width: "200",
      cellRenderer: function (params: any) {
        return (
          <>
            {params?.data.dataSourceType === 0
              ? "Accepted Claims"
              : params?.data.dataSourceType === 1
              ? "Prior Step"
              : "Manual"}
          </>
        );
      },
    },
    {
      field: "weight",
      headerName: t(
        "pages.distributions.distributionStepsTab.limitAmountTab.columnDetails.column3"
      ),
      width: "150",
      headerClass: "stepHeaderClass",
      cellClass: "align-right",
    },
    {
      field: "isFilterApplicableClasses",
      headerName: t(
        "pages.distributions.distributionStepsTab.limitAmountTab.columnDetails.column4"
      ),
      width: "250",
    },
    {
      field: "sourceManualDataSourceName",
      headerName: t(
        "pages.distributions.distributionStepsTab.limitAmountTab.columnDetails.column5"
      ),
      width: "250",
      cellRenderer: function (params: any) {
        return (
          <>
            {params?.data.sourceManualDataSourceName === null ||
            params?.data.sourceManualDataSourceName === "" ||
            params?.data.sourceManualDataSourceName === undefined ? (
              "-"
            ) : (
              <div
                style={{
                  cursor: params?.data?.sourceManualDataSourceId
                    ? "pointer"
                    : "default",
                }}
                onClick={() => {
                  if (params?.data?.sourceManualDataSourceId) {
                    nav(
                      `/case/${caseId}/manual-data-source-edit/${params?.data?.sourceManualDataSourceId}?navigatedFrom=distributionStepSummary&distributionStepId=${stepId}&distributionStepName=${dataByStepId.stepName}&distributionId=${distributionId}`
                    );
                  }
                }}
                className={
                  params?.data?.sourceManualDataSourceId
                    ? "text-bold-underline"
                    : ""
                }
              >
                {params?.data.sourceManualDataSourceName}
              </div>
            )}
          </>
        );
      },
    },
    {
      field: "distributionName",
      headerName: t(
        "pages.distributions.distributionStepsTab.limitAmountTab.columnDetails.column7"
      ),
      width: "200",
      cellRenderer: function (params: any) {
        return (
          <div
            style={{
              cursor:
                params?.data?.dataSourceType === 1 ? "pointer" : "default",
            }}
            onClick={() => {
              if (params?.data?.dataSourceType === 1) {
                nav(
                  `/case/${caseId}/distribution/${params?.data?.distributionId}`
                );
              }
            }}
            className={
              params?.data?.dataSourceType === 1 ? "text-bold-underline" : ""
            }
          >
            {params?.data.distributionName === null ||
            params?.data.distributionName === ""
              ? "-"
              : params?.data.distributionName}
          </div>
        );
      },
    },
    {
      field: "sourceCalculationStepName",
      headerName: t(
        "pages.distributions.distributionStepsTab.limitAmountTab.columnDetails.column6"
      ),
      width: "200",
      cellRenderer: function (params: any) {
        return (
          <div
            style={{
              cursor:
                params?.data?.dataSourceType === 1 ? "pointer" : "default",
            }}
            onClick={() => {
              if (params?.data?.dataSourceType === 1) {
                nav(
                  `/case/${caseId}/distribution/${params?.data?.distributionId}/calculation-step/${params?.data?.sourceCalculationStepId}/step-summary`
                );
              }
            }}
            className={
              params?.data?.dataSourceType === 1 ? "text-bold-underline" : ""
            }
          >
            {params?.data.sourceCalculationStepName === null
              ? "-"
              : params?.data.sourceCalculationStepName}
          </div>
        );
      },
    },

    {
      field: "action",
      headerName: "",
      width: "70",
      cellClass: "align-right",
      cellRenderer: function (params: any) {
        return (
          <>
            {
              havingDeletePermission(StepLimitAmount || []) && (
                <GetCommonDeleteImgButton
                  onClick={() => {
                    setShowModal(true);
                    setDeleteId(params?.data?.id);
                  }}
                  disabled={distributionStatus}
                ></GetCommonDeleteImgButton>
              )
              // <CommonTooltipWrapper tooltipTitle={t("global.globalActions.delete")}>
              // <MotifButton
              //     className="action-delete-button"
              //     size="small"
              //     variant={DELETE_IMG_VARIANT}
              //     onClick={() => {
              //       setShowModal(true);
              //       setDeleteId(params?.data?.id);
              //     }}
              //     disabled={distributionStatus}
              //   >
              // {getCommonDeleteImg()}

              //   </MotifButton>
              // </CommonTooltipWrapper>
            }
            {/* {havingEditPermission(StepLimitAmount || []) && <MotifButton
              size="small"
              variant="secondary"
              disabled={distributionStatus}
              style={{ marginLeft: "10px" }}
              onClick={() => {
                setUpdateShow(true);
                setEditId(params?.data?.id);
              }}
            <}
            {/* {havingEditPermission(StepLimitAmount || []) && <MotifButton
              size="small"
              variant="secondary"
              disabled={distributionStatus}
              style={{ marginLeft: "10px" }}
              onClick={() => {
                setUpdateShow(true);
                setEditId(params?.data?.id);
              }}
            >
              <MotifIcon
                iconFunction={IconoirEditPencil}
                stroke="blue"
                strokeWidth="2"
                size="20"
              />
            </MotifButton>} */}
          </>
        );
      },
    },
  ];
  const [deleteLimitAmount, { isLoading: deleteLoading }] =
    useDeleteLimitAmountMutation();
  async function deleteClassFilterHandler(Id: string) {
    const response = await deleteLimitAmount(Id);
    if (response.hasOwnProperty("data")) {
      refetch();
    } else {
      console.log("Error in deleting class filter");
    }
    setShowModal(false);
  }
  return (
    <>
      <MotifModal
        onClose={() => setShowModal(false)}
        show={showModal}
        focusTrapOptions={{
          tabbableOptions: {
            displayCheck: "none",
          },
        }}
      >
        <div className="confirmationModalWrapper creditor_disabling_model">
          <MotifModalHeader
            headerIcon={
              <>
                <span
                  style={{
                    backgroundColor: "rgb(252, 245, 243)",
                    borderRadius: "50px",
                    padding: "5px 8px 2px 8px",
                  }}
                >
                  <MotifIcon
                    iconFunction={IconoirWarningTriangle}
                    strokeWidth="1"
                    size="15"
                    stroke="red"
                  />{" "}
                </span>
                <span
                  style={{
                    fontSize: 16,
                    display: "block",
                    width: "100%",
                    marginLeft: "10px",
                  }}
                >
                  {t("global.globalNotifications.warning")}
                </span>
              </>
            }
          ></MotifModalHeader>

          <MotifModalBody style={{ paddingTop: "0px" }}>
            <span style={{ fontWeight: "300" }}>
              {t(
                "pages.distributions.distributionStepsTab.limitAmountTab.deleteWarningMessage"
              )}
            </span>
          </MotifModalBody>
          <MotifModalFooter>
            <MotifButton
              size="small"
              type="submit"
              variant={YES_BUTTON_VARIANT}
              style={{
                border: "1px solid #ccc",
                borderRadius: "4px",
              }}
              onClick={() => {
                deleteClassFilterHandler(deleteId);
              }}
              loading={deleteLoading}
            >
              {t("global.globalActions.yes")}
            </MotifButton>
            <MotifButton
              className=""
              onClick={() => setShowModal(false)}
              size="small"
              type="button"
              variant={CANCEL_BUTTON_VARIANT}
            >
              {t("global.globalActions.cancel")}
            </MotifButton>
          </MotifModalFooter>
        </div>
      </MotifModal>
      <Table
        columnDefs={columnClassFilterDefs}
        cellRenderers={isFetching ? [] : data}
        TitleComplement={TitleComplement}
        title={
          "pages.distributions.distributionStepsTab.limitAmountTab.tableTitle"
        }
        description={
          "pages.distributions.distributionStepsTab.limitAmountTab.tableDescription"
        }
        pagination={false}
        overlayNoRowsTemplate={
          isFetching
            ? t("global.globalNotifications.loadingMessage")
            : t("global.globalNotifications.noRecords")
        }
      />
      {updateShow && editId && editId !== "" && (
        <LimitAmountForm
          caseId={caseId}
          stepId={stepId}
          updateShow={updateShow}
          setUpdateShow={setUpdateShow}
          refetch={refetch}
          manualDataSource={manualDataSource}
          setEditId={setEditId}
          editId={editId}
          resolvedStatus={distributionStatus}
        />
      )}
      {createShow && (
        <LimitAmountFormNew
          caseId={caseId}
          stepId={stepId}
          createShow={createShow}
          setCreateShow={setCreateShow}
          refetch={refetch}
          manualDataSource={manualDataSource}
        />
      )}
    </>
  );
};
